export default {
  email: 'Email*',
  firstname: 'Your first name*',
  lastname: 'Your surname*',
  company: 'Company Name*',
  position: 'Your job*',
  phonenumber: 'Your phone number*',
  country: 'Country*',
};
